import {api} from '../components/Base/App';

export default {
    initAuth(code) {
        return api({
            method: 'get',
            url: '/rest/airbnb/auth',
            params: {
                code: code
            }

        });
    }
}



// WEBPACK FOOTER //
// ./src/api/Airbnb.js